import { Component } from 'react'
import { API, Auth } from 'aws-amplify'
import config from './Config'

const apiPath = config.apiGatewayGuest.PATH

class GuestClient extends Component {
    async checkCompany(url) {
		const data = {
			url
		}
		console.log(data)

		return API.post(apiPath, 'companies/exists', {
			body: data
		})
	}

	async addCompany(url, name, firstName, lastName, email, phone) {
		const data = {
			url,
			name,
			firstName,
			lastName,
			email,
			phone
		}
		console.log(data)

		return API.post(apiPath, 'companies/add', {
			body: data
		})
	}

	async getCompany(domain) {
		const data = {
			domain
		}
		console.log(data)

		return API.post(apiPath, 'companies/get-by-domain', {
			body: data
		})
	}

	async checkWebsiteBadge(companyId, url) {
		const data = {
			companyId,
			url
		}
		console.log(data)

		return API.post(apiPath, 'companies/check-badge', {
			body: data
		})
	}

	// async sendDeveloperInstructions(url, email) {
	// 	const data = {
	// 		url,
	// 		email
	// 	}
	// 	console.log(data)

	// 	return API.post(apiPath, 'companies/send-developer-email', {
	// 		body: data
	// 	})
	// }
} 

export default GuestClient